import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { selectPhotoIdsByGroupId } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectActiveVariant, selectIsEmptyGroup } from '../_redux-groups';

interface GroupState<TVariant = unknown> {
  photoIds: string[];
  activeVariant: TVariant;
  isEmpty: boolean;
}

const createGroupSelector = (groupId: string) =>
  createSelector(
    [
      (state: PhotoPrintsPdpState) => selectPhotoIdsByGroupId(state, groupId),
      (state: PhotoPrintsPdpState) => selectActiveVariant(state, groupId),
      (state: PhotoPrintsPdpState) => selectIsEmptyGroup(state, groupId)
    ],
    (photoIds, activeVariant, isEmpty): GroupState => ({
      photoIds,
      activeVariant,
      isEmpty
    })
  );

export const useMemoizedGroup = (groupId: string) => {

  const selector = useMemo(() => createGroupSelector(groupId), [groupId]);

  return useSelector(selector, shallowEqual);
};